module.exports = __webpack_public_path__ + "img/231ca99bde48c0f6c8f1b88191ee1888.png";